module.exports = __webpack_public_path__ + "img/bank-interbank.1259edab.png";